// extracted by mini-css-extract-plugin
export default {"charts":"Widgets_charts__66X4D","widgets":"Widgets_widgets__YkyFJ"};